<div class="colab-manager-content-component colab-autoupdate fade-in-animation">
  <div class="row" style="margin: 0;">

    <div class="col-md-12 col-sm-12">

      <div class="header-card">
        <h1 class="no-margin">
          Atualização automática
        </h1>
        <p>Token da empresa: {{companyId}}</p>
      </div>

      <p class="text-wrp">
        Facilite o seu dia a dia integrando a Allya com o sistema que você utiliza para manter suas informações atualizadas.<br />
        Acessando o próximo link, você poderá obter a documentação de nossa API para que o departamento de TI de sua empresa possa fazer a integração.
        <br />
        <a href="{{apiDocumentation}}" target="blank">Acesse a documentação aqui.</a>
        <br />
        Qualquer dúvida, entre em contato conosco.
      </p>

    </div>

  </div>
</div>
